module.exports = __webpack_public_path__ + "img/99.efa2dfd9.webp";